import { X, Trash2 } from "lucide-react";

export default function ConfirmDeleteModal({
  open,
  onClose,
  onConfirm,
  title = "Delete Confirmation",
  description = "Are you sure you want to delete this information? This action cannot be undone.",
  confirmText = "Delete",
  cancelText = "Cancel",
}) {
  if (!open) return null;

  return (
    <div className="font-inter fixed inset-0 z-[1100] flex items-center justify-center bg-black/40">
      <div className="relative w-full max-w-md rounded-2xl bg-white p-6 shadow-[0px_8px_30px_rgba(0,0,0,0.2)]">
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute right-4 top-4 text-gray-400 hover:text-gray-600"
        >
          <X size={20} />
        </button>

        {/* Icon */}
        <div className="mb-4 flex justify-center">
          <div className="flex h-14 w-14 items-center justify-center rounded-full bg-red-100">
            <Trash2 className="text-red-600" size={26} />
          </div>
        </div>

        {/* Title */}
        <h2 className="mb-2 text-center text-lg font-semibold text-gray-900">
          {title}
        </h2>

        {/* Description */}
        <p className="mb-6 text-center text-sm text-gray-600">{description}</p>

        {/* Actions */}
        <div className="flex gap-3">
          <button
            onClick={onClose}
            className="flex-1 rounded-lg border border-gray-200 px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-100"
          >
            {cancelText}
          </button>

          <button
            onClick={onConfirm}
            className="flex-1 rounded-lg bg-[#572575] px-4 py-2 text-sm font-medium text-white hover:bg-[#4a2372]"
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
}
